import { TChatbotActions } from './chatbot.actions';
import { TChatbotState, TChatbotActionType } from './chatbot.models';

export const intialState: TChatbotState = {
  chatbotChatUiModel: null,
};

export function chatbotReducer(state = intialState, action: TChatbotActions): TChatbotState {
  switch (action.type) {
    case TChatbotActionType.SetChatbotChatUiModel:
      return {
        ...state,
        chatbotChatUiModel: action.payload,
      };
    default:
      return state;
  }
}
